import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import { AdminRoute } from "@/components/auth/AdminRoute";
import AdminInstitutions from "@/pages/admin/AdminInstitutions";

export const Route = createFileRoute("/admin/instituicoes")({
  head: () => seoHead({
    title: "Administração | Shopping do Bem",
    description: "Área administrativa do Shopping do Bem.",
    noindex: true,
  }),
  component: () => (
    <AdminRoute>
      <AdminInstitutions />
    </AdminRoute>
  ),
});
